import React from 'react';

import { Banner as VKBanner, Button } from '@vkontakte/vkui';

import styles from './index.module.css';
import { BannerProps } from './types';

export const Banner: React.FC<BannerProps> = ({ onAppWithTestsClick }) => {
  return (
    <div>
      <VKBanner
        mode="image"
        size="s"
        header={<span>
            Узнать больше
          <br />о профессиональном типе
        </span>}
        style={{ padding: 12 }}
        subheader={
          <span>
            Пройдите больше тестов
            <br />в нашем приложении
          </span>
        }
        background={<div className={styles.background}/>}
        actions={
          <Button 
            appearance="overlay"
            size="m"
            onClick={onAppWithTestsClick}
          >
            Перейти
          </Button>
        }
      />
    </div>
  );
};
